var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VTableHeader',{staticClass:"table-header"},[_c('VGridCol',[_vm._v("№")]),_c('VGridCol',[_vm._v("Проект")]),_c('VGridCol',[_vm._v("Город")]),_c('VGridCol',[_vm._v("Генподрядчик")]),_c('VGridCol',[_vm._v("Автор")]),_c('VGridCol',[_vm._v("Дата осмотра")]),_c('VGridCol',[_vm._v("Баллы")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }